import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { SearchDialog } from '../SearchDialog';
import { AssignmentForm } from './AssigmentForm';

const SearchDialogWithForm = ({ onCreate, ...rest }) => {
  const [formData, setFormData] = useState({ isValid: undefined, data: {} });

  const handleStart = useCallback(
    ids => {
      onCreate(
        ids,
        formData.data.level,
        formData.data.reason,
        formData.data.relation,
      );
    },
    [formData],
  );

  return (
    <SearchDialog
      extraValidation={formData.isValid}
      onCreate={handleStart}
      {...rest}
    >
      <AssignmentForm onFormChange={setFormData} />
    </SearchDialog>
  );
};

SearchDialogWithForm.propTypes = {
  onCreate: PropTypes.func.isRequired,
};

export default SearchDialogWithForm;



// WEBPACK FOOTER //
// ./src/components/common/SearchDialogWithForm/index.jsx